export const GAME_STATUS = {
	NOT_INITIALIZE: "not initialize",
	NOT_STARTED: "pending",
	IN_PROGRESS: "started",
	FINISHED: "ended",
	SUMMARIZED: "summarized",
};
